import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'util';
import * as L from 'leaflet';
import { color } from 'highcharts';
import { isEmptyField } from 'src/app/main/shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { HttperrorhandlerService } from 'src/app/main/shared/http/httperrorhandler.service';


@Injectable({
  providedIn: 'root'
})
export class HeatwaveDataService {
  mandalData: Object;

  urlConst: any = environment.url.HEATWAVE_STAGING_API_URL
  combinedTimeStampList: any;

  constructor(private http: HttpClient, private utils: UtilsService, private datePipe: DatePipe,private errorHandler: HttperrorhandlerService) { }

  getActualData(postData) {
    let url: any;
    url = this.urlConst + 'heatWatches/getObservedHeatWatchesData';
    return this.http.post<any>(url, postData);
  }

  getAccuracyData(postData) {
    let url: any;
    url = this.urlConst + 'hw/getHWAccuracyData';
    return this.http.post<any>(url, postData);
  }

  getDistrictData(postData) {
    let url: any;
    url = this.urlConst + 'heatWatches/getHeatWatchesData';
    return this.http.post<any>(url, postData);
  }

  getForecastData(postData): Observable<any> {
    return this.http.post(this.urlConst + "hw/getForecastData", postData)
  }

  getActualTemperatureData(postData): Observable<any> {
    return this.http.post(this.urlConst + "heatWatches/getActualTemperatureData", postData)
  }

  getPostDataForHW(queryParams) {
    const today = new Date();
    const startTs = today.getTime() - (3 * 24 * 60 * 60 * 1000);
    const endTs = queryParams['source'] != 'ECMWF' ? today.getTime() + (6 * 24 * 60 * 60 * 1000) : today.getTime() + (45 * 24 * 60 * 60 * 1000);
    let distUUID;
    if (queryParams['locType'] == 'DISTRICT') {
      let allLocations = queryParams['location'].split('&')
      distUUID = allLocations[1].split('##')[1]
    }
    let postData = {
      component: "HEATWAVE",
      "sUUID": queryParams['locType'] != 'DISTRICT' ? '00cb31c7-2928-4e6d-adcc-443d478c90d6' : distUUID,
      "pUUID": queryParams['locType'] != 'DISTRICT' ? '00cb31c7-2928-4e6d-adcc-443d478c90d6' : distUUID,
      "pType": queryParams['locType'] != 'DISTRICT' ? "COUNTRY" : "STATE",
      "cType": queryParams['locType'] != 'DISTRICT' ? "DISTRICT" : "BLOCK",
      "source": queryParams['source'],
      "startTs": startTs,
      "endTs": endTs
    }

    return postData
  }

  getTableDistrictData(postData) {
    let url = this.urlConst + "heatWatches/getHeatWatchesCount";
    return this.http.post<any>(url, postData);
  }

  getTableActualData(postData) {
    let url = this.urlConst + "heatWatches/getActualHeatWaveCount";
    return this.http.post<any>(url, postData);
  }

  getTableAccuracyData(postData) {
    let url = this.urlConst + "hw/getHWAccuracyData";
    return this.http.post<any>(url, postData);
  }

  getTableBlockActualData(postData){
    let url = this.urlConst + "heatWatches/getObservedHeatWatchesData";
    return this.http.post<any>(url, postData);
  }

  getTableBlockHeatWaveData(postData) {
    let url = this.urlConst + "heatWatches/getHeatWatchesData";
    return this.http.post<any>(url, postData);
  }

  getHeirarchy(postData) {
    let url = this.urlConst + "locations/heirarchy";
    return this.http.post<any>(url, postData)
  }

    public getFeatureInfo(latlng: any, layer: any, map: any) {
      let url = this.getFeatureInfoUrl(latlng, layer, map);
      return this.http.get(url).pipe(
        catchError((err) => {
          return EMPTY;
        })
      );
    }
    public getFeatureInfoUrl(latlng: any, layer: any, map: any) {
      // if(!isNullOrUndefined(latlng.latlng)){
      //   latlng = latlng.latlng
      // }
      let point = map.latLngToContainerPoint(latlng, map.getZoom());
      let size = map.getSize();
      let params: any = {
        request: 'getFeatureInfo',
        service: 'WMS',
        srs: 'EPSG:4326',
        transparent: true,
        version: layer ? layer.wmsParams.version : '',
        format: layer ? layer.wmsParams.format : '',
        bbox: map.getBounds().toBBoxString(),
        height: Math.floor(size.y),
        width: Math.floor(size.x),
        layers: layer ? layer.wmsParams.layers : '',//queryLayers.join(','),
        query_layers: layer ? layer.wmsParams.layers : '',//queryLayers.join(','),
        info_format: 'application/json',
        feature_count: 50,
        VIEWPARAMS: layer ? (layer.wmsParams.VIEWPARAMS ? layer.wmsParams.VIEWPARAMS : '1=1') : ''
        // CQL_FILTER: layer ? (layer.wmsParams.cql_filter ? layer.wmsParams.cql_filter : '1=1') : ''
      };
      params[params.version === '1.3.0' ? 'i' : 'x'] = Math.floor(point.x);
      params[params.version === '1.3.0' ? 'j' : 'y'] = Math.floor(point.y);
      let url = layer._url + (L as any).Util.getParamString(params, layer._url, true);
      return url;
    }

  formatMandalData(data, hval, hcat, gis, actualData?) {
    let totalTableData: any;
    if (actualData.length > 0) {
      totalTableData = this.fetchTotData(actualData, data);
    } else {
      totalTableData = data
    }
    return new Promise((resolve, reject) => {
      const finalData = {};
      const timeStampList = [];
      let currentDate = this.getCurrentDateInYYYYMMDDFormat1();
      for (const locName of Object.keys(data)) {
        if (data[locName]['table_data'] == null || data[locName]['table_data'] == undefined) {
          continue;
        }
        let table_data = {};
        for (const index of totalTableData[locName]['table_data']) {
          if (!timeStampList.includes(index['timeStamp'])) {
            timeStampList.push(index['timeStamp']);
          }
          if (index['timeStamp'] == currentDate && totalTableData[locName]['table_data'].length > 0) {
            for (let actualLocName of Object.keys(totalTableData)) {
              if (totalTableData[actualLocName]['uuid'] == data[locName]['uuid']) {
                table_data[index['timeStamp']] = {
                  val: totalTableData[actualLocName]['table_data'][0]['data'][hval],
                  cat: totalTableData[actualLocName]['table_data'][0]['data'][hcat]
                };
              }
            }

          } else {
            table_data[index['timeStamp']] = {
              val: index['data'][hval],
              cat: index['data'][hcat]
            };
          }
        }
        const locData = {
          name: data[locName].name,
          pName: data[locName].pName,
          uuid: data[locName].name,
          'table_data': table_data
        };
        finalData[data[locName].uuid] = locData;
      }
      const sortedTimeStampList = this.combinedTimeStampList.sort();
      // const sortedTimeStampList = timeStampList.sort();
      gis.labelStrings = this.createLabels(sortedTimeStampList);
      let index: any = this.setBlockNumber();
      gis.activeGroup = sortedTimeStampList[index];
      resolve(finalData);
    })
  }

  fetchTotData(dataA: any, dataB: any) {
    let objA: any = this.fetchObj(dataA);
    let objB: any = this.fetchObj(dataB);
    let keys: any = Object.keys(objA);
    let finalArr: any = [];
    let obj: any = {}
    for (let i: any = 0; i < keys.length; i++) {
      let obj: any = {};
      obj = { ...obj, ...objA[keys[i]] };
      let newArr: any = [];
      newArr = newArr.concat(objA[keys[i]]['table_data']);
      if (!isNullOrUndefined(objB[keys[i]])) {
        newArr = newArr.concat(objB[keys[i]]['table_data']);
      }
      obj['table_data'] = this.removeDuplicates(newArr);

      finalArr.push(obj);
    }
    return finalArr;
  }

  fetchToTableData(dataA: any, dataB: any) {
    let objA: any = this.fetchObj(dataA);
    let objB: any = this.fetchObj(dataB);
    let keys: any = Object.keys(objA);
    let finalArr: any = [];
    let obj: any = {}
    for (let i: any = 0; i < keys.length; i++) {
      let obj: any = {};
      obj = { ...obj, ...objA[keys[i]] };
      let newArr: any = [];
      newArr = newArr.concat(objA[keys[i]]['table_data']);
      newArr = newArr.concat(objB[keys[i]]['table_data']);
      obj['table_data'] = this.concatenateDataByTimestamp(newArr);

      finalArr.push(obj);
    }
    return finalArr;
  }

  concatenateDataByTimestamp(dataArray) {
    const groupedData = {};

    // Group data by timestamp
    dataArray.forEach(item => {
      const timestamp = item.timeStamp;
      const data = item.data;

      if (!groupedData[timestamp]) {
        groupedData[timestamp] = [data];
      } else {
        groupedData[timestamp].push(data);
      }
    });
    const concatenatedData = [];
    for (const timestamp in groupedData) {
      if (groupedData.hasOwnProperty(timestamp)) {
        const concatenatedObject = groupedData[timestamp].reduce((acc, curr) => {
          return { ...acc, ...curr };
        }, {});
        concatenatedData.push({ timeStamp: parseInt(timestamp), data: concatenatedObject });
      }
    }
    return concatenatedData;
  }

  fetchObj(data: any) {
    let obj: any = {};
    for (let i: any = 0; i < data.length; i++) {
      obj[data[i]['uuid']] = data[i];
    }

    return obj;
  }

  removeDuplicates(data: any) {
    const uniqueTimestamps = new Set<number>();
    const filteredData = data.filter(item => {
      if (!uniqueTimestamps.has(item.timeStamp)) {
        uniqueTimestamps.add(item.timeStamp);
        return true;
      }
      return false;
    });
    return filteredData;
  }

  getCurrentDateInYYYYMMDDFormat1() {
    const currentDate = new Date();
    const threeDaysAgo = new Date(currentDate);
    threeDaysAgo.setDate(currentDate.getDate() - 3); // Set date to three days ago

    const year = threeDaysAgo.getFullYear();
    const month = String(threeDaysAgo.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(threeDaysAgo.getDate()).padStart(2, '0');

    const formattedDate = `${year}${month}${day}`;
    return formattedDate;
  }

  formatStateData(data, actualData, accuracyData) {
    // console.log(data,actualData,accuracyData,"accuracydata1122")
    if (!isNullOrUndefined(data) && !isNullOrUndefined(actualData)) {
      let finalData = {};
      let timeStampList = []
      let table_data = []
      // let formattedActualData = this.formatAccuracyData(actualData, accuracyData)
      let formattedActualData:any;
      if (!isNullOrUndefined(actualData) && !isNullOrUndefined(accuracyData)) {
        formattedActualData = this.formatAccuracyData(actualData, accuracyData);
      }
      // console.log(formattedActualData,"formattedActualData")
      let foramtted = this.fetchToTableData(data,actualData);
      // console.log(formattedActualData,"formattedActualData",foramtted);
      let currentDate = this.getCurrentDateInYYYYMMDDFormat();
      for (let locName in foramtted) {
        let locObject = {}
        locObject['State'] = { val: this.utils.formatNames(foramtted[locName]['name']) };
        locObject['uuid'] = foramtted[locName]['uuid'];
        for (let element in foramtted[locName]['table_data']) {
          if (foramtted[locName]['table_data'][element]['data'] == null || foramtted[locName]['table_data'][element]['data'] == undefined) {
            continue;
          }
          let timeStamp = foramtted[locName]['table_data'][element]['timeStamp'].toString();
          // console.log(timeStamp,currentDate,"currentDate")
          if(timeStamp >= currentDate) {
          // let accuracy = formattedActualData[locName]['table_data'][0]['data']['a']
            let accuracy = 0;
            if (
              formattedActualData && formattedActualData[locName] && Array.isArray(formattedActualData[locName]['table_data']) && formattedActualData[locName]['table_data'][0] && formattedActualData[locName]['table_data'][0]['data']) {
              accuracy = formattedActualData[locName]['table_data'][0]['data']['a'];
            }
          // let timeStamp = element['timeStamp'];
          if (!timeStampList.includes(timeStamp)) {
            timeStampList.push(timeStamp);
          }
          if (timeStamp == currentDate) {
            let timeC = timeStamp.toString() + "_" + "c";
            locObject[timeC] = { val: formattedActualData[locName]['table_data'][element] ? formattedActualData[locName]['table_data'][element]['data']['c'] : '0' };
            let timeD = timeStamp.toString() + "_" + "d";
            locObject[timeD] = { val: formattedActualData[locName]['table_data'][element] ? formattedActualData[locName]['table_data'][element]['data']['d'] : '0' };
            // if(timeStamp == currentDate) {
            let timeE = timeStamp.toString() + "_" + "a";
            locObject[timeE] = { val: accuracy };
            // }
          }
           else {
            let timeC = timeStamp.toString() + "_" + "c";
            locObject[timeC] = { val: foramtted[locName]['table_data'][element]['data']['c'] };
            let timeD = timeStamp.toString() + "_" + "d";
            locObject[timeD] = { val: foramtted[locName]['table_data'][element]['data']['d'] };
            // if(timeStamp == currentDate) {
            //   let timeE = timeStamp.toString() + "_" + "ac";
            //   locObject[timeE] = { val : data[locName]['table_data'][element]['data']['ac']};
            // }
          }
          }
        }
        // console.log(data[locName]);
        if (foramtted[locName]['centroid'] != undefined && foramtted[locName]['centroid'] != null) {
          locObject['centroid'] = foramtted[locName]['centroid'];
        }
        // console.log(locObject,"locobject123");
        table_data.push(locObject);
        // console.log(table_data,"tabledata12")
        // table_data.sort((a, b) => {
        //   let sumA = (a[currentDate + '_c'].val || 0) + (a[currentDate + '_d'].val || 0);
        //   let sumB = (b[currentDate + '_c'].val || 0) + (b[currentDate + '_d'].val || 0);
        //   return sumB - sumA;
        // });
        table_data.sort((a, b) => {
          let sumA = ((a[currentDate + '_c'] && a[currentDate + '_c'].val) || 0) +((a[currentDate + '_d'] && a[currentDate + '_d'].val) || 0);
          let sumB = ((b[currentDate + '_c'] && b[currentDate + '_c'].val) || 0) +((b[currentDate + '_d'] && b[currentDate + '_d'].val) || 0);
          return sumB - sumA;
        });
        // console.log(table_data,"tabledata123")
      }
      let sortedTimeStampList = timeStampList.sort()
      let column1 = [];
      column1.push({
        val: 'State / UT',
        colspan: 1,
        rowspan: 2,
        sortedHeaderVal: 'State',
      })
      let column2 = [];
      let tableHeaders = [];
      tableHeaders.push({ val: 'State' });
      for (let index in sortedTimeStampList) {
        let tp = sortedTimeStampList[index];
        column1.push({
          val: tp == currentDate ? this.utils.convertModelDatetoDate(tp).toLocaleDateString() + ' (' + 'Observed' + ')' : this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
          colspan: tp == currentDate ? 3 : 2,
          rowspan: 1,
          sortedHeaderVal: tp.toString() + "_d"
        })
        column2.push({
          val: 'Heatwave',
          colspan: 1,
          rowspan: 1,
          backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
          sortedHeaderVal: tp.toString() + "_c"
        })
        column2.push({
          val: 'Severe Heatwave',
          colspan: 1,
          rowspan: 1,
          backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.severe_heat_waves,
          sortedHeaderVal: tp.toString() + "_d"
        })
        if (tp == currentDate) {
          column2.push({
            val: 'Accuracy (%)',
            colspan: 1,
            rowspan: 1,
            backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.Accuracy,
            sortedHeaderVal: tp.toString() + "_a"
          })
        }
        tableHeaders.push({
          val: tp.toString() + "_c"
        })
        tableHeaders.push({
          val: tp.toString() + "_d"
        })
        if (tp == currentDate) {
          tableHeaders.push({
            val: tp.toString() + "_a"
          })
        }
      }
      let tableColumns = []
      tableColumns.push(column1);
      tableColumns.push(column2);
      finalData['data'] = table_data;
      finalData['columns'] = tableColumns;
      finalData['tableHeaders'] = tableHeaders;
      return finalData;
    }
  }


  formatDistrictData(data, actualData?, accuracyData?) {
    let finalData = {};
    let timeStampList = []
    let table_data = []
    let currentDate = this.getCurrentDateInYYYYMMDDFormat();
    // let formattedActualData = this.formatAccuracyData(actualData, accuracyData)
    let formattedActualData: any;
    if (!isNullOrUndefined(actualData) && !isNullOrUndefined(accuracyData)) {
      formattedActualData = this.formatAccuracyData(actualData, accuracyData);
    }
    let foramtted = this.fetchToTableData(data,actualData);
    // let foramtted: any;
    // if (data && data.table_data && actualData && actualData.table_data) {
    //   foramtted = this.fetchToTableData(data, actualData);
    // }
    // console.log(formattedActualData,foramtted,"iiiiiiiiiiiii")
    for (let locName in foramtted) {
      let locObject = {}
      locObject['District'] = { val: this.utils.formatNames(foramtted[locName]['name']) };
      locObject['uuid'] = (foramtted[locName]['uuid']);
      for (let element in foramtted[locName]['table_data']) {
        if (foramtted[locName]['table_data'][element]['data'] == null || foramtted[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = foramtted[locName]['table_data'][element]['timeStamp'];
        if(timeStamp >= currentDate) {
          let accuracy = formattedActualData[locName]['table_data'][0]['data']['a']
          if (!timeStampList.includes(timeStamp)) {
            timeStampList.push(timeStamp);
          }
          if (timeStamp == currentDate) {
            let timeC = timeStamp.toString() + "_" + "c";
            locObject[timeC] = { val: formattedActualData[locName]['table_data'][element] ? formattedActualData[locName]['table_data'][element]['data']['c'] : '0'};
            let timeD = timeStamp.toString() + "_" + "d";
            locObject[timeD] = { val: formattedActualData[locName]['table_data'][element] ? formattedActualData[locName]['table_data'][element]['data']['d'] : '0'};
            if (timeStamp == currentDate) {
              let timeE = timeStamp.toString() + "_" + "a";
              locObject[timeE] = { val: accuracy };
            }
          }
          // if (timeStamp == currentDate) {
          //   const matchingData = formattedActualData[locName]['table_data'].find(t => t.timeStamp == currentDate);

          //   if (matchingData) {
          //     let timeC = timeStamp.toString() + "_c";
          //     locObject[timeC] = { val: matchingData.data.c !== undefined ? matchingData.data.c : '-' };

          //     let timeD = timeStamp.toString() + "_d";
          //     locObject[timeD] = { val: matchingData.data.d !== undefined ? matchingData.data.d : '-' };

          //     let timeE = timeStamp.toString() + "_a";
          //     locObject[timeE] = { val: accuracy };
          //   }
          // }
          else {
            let timeC = timeStamp.toString() + "_" + "c";
            locObject[timeC] = { val: foramtted[locName]['table_data'][element]['data']['c'] };
            let timeD = timeStamp.toString() + "_" + "d";
            locObject[timeD] = { val: foramtted[locName]['table_data'][element]['data']['d'] };
            // if(timeStamp == currentDate) {
            //   let timeE = timeStamp.toString() + "_" + "ac";
            //   locObject[timeE] = { val : data[locName]['table_data'][element]['data']['ac']};
            // }
          }
        }
      }
      // console.log(data[locName]);
      if (foramtted[locName]['centroid'] != undefined && foramtted[locName]['centroid'] != null) {
        locObject['centroid'] = foramtted[locName]['centroid'];
      }
      table_data.push(locObject);
    }
    // table_data.sort((a, b) => {
    //   let sumA =  (a[currentDate + '_d'].val || 0)
    //   let sumB =  (b[currentDate + '_d'].val || 0)
    //   return sumB - sumA;
    // });
    // table_data.sort((a, b) => {
    //   let sumA = (a[currentDate + '_d'] && a[currentDate + '_d'].val) || 0;
    //   let sumB = (b[currentDate + '_d'] && b[currentDate + '_d'].val) || 0;
    //   return sumB - sumA;
    // });
    table_data.sort((a, b) => {
      let sumA = ((a[currentDate + '_c'] && a[currentDate + '_c'].val) || 0) +((a[currentDate + '_d'] && a[currentDate + '_d'].val) || 0);
      let sumB = ((b[currentDate + '_c'] && b[currentDate + '_c'].val) || 0) +((b[currentDate + '_d'] && b[currentDate + '_d'].val) || 0);
      return sumB - sumA;
    });
    let sortedTimeStampList = timeStampList.sort()
    let column1 = [];
    column1.push({
      val: 'District',
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: 'District',
    })
    let column2 = [];
    let tableHeaders = [];
    tableHeaders.push({ val: 'District' });
    for (let index in sortedTimeStampList) {
      let tp = sortedTimeStampList[index];
      column1.push({
        val: tp == currentDate ? this.utils.convertModelDatetoDate(tp).toLocaleDateString() + ' (' + 'Observed' + ')' : this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan: tp == currentDate ? 3 : 2,
        rowspan: 1,
        sortedHeaderVal: tp.toString() + "_d"
      })
      column2.push({
        val: 'Heatwave',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
        sortedHeaderVal: tp.toString() + "_c"
      })
      column2.push({
        val: 'Severe Heatwave',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.severe_heat_waves,
        sortedHeaderVal: tp.toString() + "_d"
      })
      if (tp == currentDate) {
        column2.push({
          val: 'Accuracy (%)',
          colspan: 1,
          rowspan: 1,
          backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.Accuracy,
          sortedHeaderVal: tp.toString() + "_a"
        })
      }
      tableHeaders.push({
        val: tp.toString() + "_c"
      })
      tableHeaders.push({
        val: tp.toString() + "_d"
      })
      if (tp == currentDate) {
        tableHeaders.push({
          val: tp.toString() + "_a"
        })
      }
    }
    let tableColumns = []
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = table_data;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    // console.log(finalData,"finaldata123");
    return finalData;
  }

  formatMandalDataForTable(data, hval, hcat, actualData?, accuracyDataForMandal?, component?) {
    let finalData = {};
    let table_dataForMandal = [];
    let timeStampList = [];
    let currentDate = this.getCurrentDateInYYYYMMDDFormat()
    let accuracyData = this.fetchObj(accuracyDataForMandal);
    let foramtted = this.fetchToTableData(data,actualData);
    for (let locName of Object.keys(data)) {
      if (data[locName]['table_data'] == null || data[locName]['table_data'] == undefined) {
        continue;
      }
      let locObject = {};
      let accuracyVal :any;
      for (let index of foramtted[locName]['table_data']) {
        if(index['timeStamp'] >= currentDate) {
          if (!timeStampList.includes(index['timeStamp'])) {
            timeStampList.push(index['timeStamp']);
          }
          if (index['timeStamp'] == currentDate) {
            for(let actualLocName of Object.keys(actualData)) {
              if (!(Number(actualData[actualLocName]['table_data'][0]['data'][hval]).toFixed(2) == "NaN") && actualData[actualLocName]['uuid'] == data[locName]['uuid']) {
                locObject[index['timeStamp']] = {
                  val: Number(actualData[actualLocName]['table_data'][0]['data'][hval]).toFixed(2),
                  backgroundColor: component == 'HEATINDEX' ? ProjConstants.DISCOMFORT_INDEX_LEGEND[index['data'][hcat]] : ProjConstants.HEAT_WATCHES_LEGEND[actualData[actualLocName]['table_data'][0]['data'][hcat]],
                  accuracy: accuracyData[data[locName]['uuid']]['table_data'][0]['data']['accuracy']
                }
                let c:any = index['timeStamp'].toString()+"_a";
                locObject[index['timeStamp']][c] = Number(accuracyData[data[locName]['uuid']]['table_data'][0]['data']['accuracy']* 100).toFixed(2)
              }
            }
          } else {
            if (!(Number(index['data'][hval]).toFixed(2) == "NaN")) {
              locObject[index['timeStamp']] = {
                val: Number(index['data'][hval]).toFixed(2),
                backgroundColor: component == 'HEATINDEX' ? ProjConstants.DISCOMFORT_INDEX_LEGEND[index['data'][hcat]] : ProjConstants.HEAT_WATCHES_LEGEND[index['data'][hcat]],
                // accuracy: accuracyData[data[locName]['uuid']]['table_data'][0]['data']['accuracy']
              }
            }
          }

        }
      }
      locObject['District'] = { val: this.utils.formatNames(data[locName]['pName']) }
      locObject['Mandal'] = { val: this.utils.formatNames(data[locName]['name']) }
      if (data[locName]['centroid'] != undefined && data[locName]['centroid'] != null) {
        locObject['centroid'] = data[locName]['centroid'];
      }
      table_dataForMandal.push(locObject)
    }
    let sortedTimeStampList = timeStampList.sort();
    let column1 = [];
    let column2 = []
    column1.push({
      val: 'Mandal',
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: 'Mandal',
    })
    // column1.push({
    //   val: 'District',
    //   colspan: 1,
    //   rowspan: 1,
    //   sortedHeaderVal: 'District',
    // })
    let tableHeaders = [];
    tableHeaders.push({ val: 'Mandal' });
    tableHeaders.push({ val: 'District' });
    for (let index in sortedTimeStampList) {
      let tp = sortedTimeStampList[index];
      let isFirst = parseInt(index) === 0;
      column1.push({
        val: tp == currentDate ? this.utils.convertModelDatetoDate(tp).toLocaleDateString()  : this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan: tp == currentDate ? 2 : 1,
        rowspan: 1,
        sortedHeaderVal: tp.toString()
      })
      // if (tp == currentDate) {
        column2.push({
        // val: 'Observed',
        val: isFirst ? 'Observed' : 'Forecast',
          colspan: 1,
          rowspan: 1,
          // backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
          // sortedHeaderVal: tp.toString() + "_c"
        })
      // }
      if (tp == currentDate) {
        column2.push({
          val: 'Accuracy (%)',
          colspan: 1,
          rowspan: 1,
          backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.Accuracy,
          sortedHeaderVal: tp.toString() + "_a"
        })
        // column2.push({
        //   val: 'Accuracy',
        //   colspan: 1,
        //   rowspan: 1,
        //   backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.Accuracy,
        //   sortedHeaderVal: 'accuracy'
        // })
      }
      tableHeaders.push({
        val: tp.toString()
      })
      if (tp == currentDate) {
        tableHeaders.push({
          val: tp
        })
      }
    }
    let tableColumns = []
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = table_dataForMandal;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  formatAccuracyData(actualData, accuracyData) {
    let formattedData = this.fetchObj(this.fetchToTableData(actualData, accuracyData));
    // console.log(formattedData,"formattedDataformattedData")
    let currentDate = this.getCurrentDateInYYYYMMDDFormat()
    for (let i in actualData) {
      if (formattedData[actualData[i]['uuid']]) {
        let val: any = formattedData[actualData[i]['uuid']];

        actualData[i]['table_data'][0]['data']['a'] = (((this.fetchData(currentDate, val['table_data'])) * 100).toFixed(2))
      }
    }
    return actualData
  }

  fetchData(date: any, data: any) {
    for (let i: any = 0; i < data.length; i++) {
      if (data[i]['timeStamp'] == date) {
        return data[i]['data']['accuracy']
      }
    }

    return '-';
  }

  getCurrentDateInYYYYMMDDFormat() {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();

    let displayDate;

    if (currentHour > 17 || (currentHour === 17 && currentMinutes >= 30)) {
      // After 5:30 PM
      displayDate = currentDate;
    } else {
      // Before 5:30 PM
      const yesterday = new Date(currentDate);
      yesterday.setDate(currentDate.getDate() - 1); // Set date to yesterday
      displayDate = yesterday;
    }

    const year = displayDate.getFullYear();
    const month = String(displayDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(displayDate.getDate()).padStart(2, '0');

    const formattedDate = `${year}${month}${day}`;
    return formattedDate
  }


  formatChartData(data, chartDataString, actualData?) {
    let timeStampList = []
    let blockArray = []
    let formattedChartData = [{}, {}, {}];
    formattedChartData[0][chartDataString] = "Severe Heatwave";
    formattedChartData[1][chartDataString] = "Heatwave";
    formattedChartData[2][chartDataString] = "Normal";
    // formattedChartData[3][chartDataString] = "Accuracy";

    let chartData = {
      "SevereHeatwave": {},
      "Heatwave": {},
      "Normal": {}
    };
    let count = 0
    let currentDate = this.getCurrentDateInYYYYMMDDFormat();
    for (let locName in data) {
      let locObject = {}
      for (let element in data[locName]['table_data']) {
        if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if (!timeStampList.includes(timeStamp)) {
          timeStampList.push(timeStamp);
        }
        let date = this.utils.convertModelDatetoDate(timeStamp).toLocaleDateString();
        if (timeStamp == currentDate) {
          if (chartData["SevereHeatwave"][date] == undefined && formattedChartData[0][date] == undefined) {
            chartData["SevereHeatwave"][date] = actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['d'];
            formattedChartData[0][date] = actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['d'];;
          }
          else {
            chartData["SevereHeatwave"][date] += actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['d'];;
            formattedChartData[0][date] += actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['d'];;
          }
          if (chartData["Heatwave"][date] == undefined && formattedChartData[1][date] == undefined) {
            chartData["Heatwave"][date] = actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['c'];
            formattedChartData[1][date] = actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['c'];
          }
          else {
            chartData["Heatwave"][date] += actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['c'];
            formattedChartData[1][date] += actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['c'];
          }
          if (chartData["Normal"][date] == undefined && formattedChartData[2][date] == undefined) {
            chartData["Normal"][date] = actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['n'];
            formattedChartData[2][date] = actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['n'];
          }
          else {
            chartData["Normal"][date] += actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['n'];
            formattedChartData[2][date] += actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['n'];
          }
        } else {
          if (chartData["SevereHeatwave"][date] == undefined && formattedChartData[0][date] == undefined) {
            chartData["SevereHeatwave"][date] = data[locName]['table_data'][element]['data']['d'];
            formattedChartData[0][date] = data[locName]['table_data'][element]['data']['d'];
          }
          else {
            chartData["SevereHeatwave"][date] += data[locName]['table_data'][element]['data']['d'];
            formattedChartData[0][date] += data[locName]['table_data'][element]['data']['d'];
          }
          if (chartData["Heatwave"][date] == undefined && formattedChartData[1][date] == undefined) {
            chartData["Heatwave"][date] = data[locName]['table_data'][element]['data']['c'];
            formattedChartData[1][date] = data[locName]['table_data'][element]['data']['c'];
          }
          else {
            chartData["Heatwave"][date] += data[locName]['table_data'][element]['data']['c'];
            formattedChartData[1][date] += data[locName]['table_data'][element]['data']['c'];
          }
          if (chartData["Normal"][date] == undefined && formattedChartData[2][date] == undefined) {
            chartData["Normal"][date] = data[locName]['table_data'][element]['data']['n'];
            formattedChartData[2][date] = data[locName]['table_data'][element]['data']['n'];
          }
          else {
            chartData["Normal"][date] += data[locName]['table_data'][element]['data']['n'];
            formattedChartData[2][date] += data[locName]['table_data'][element]['data']['n'];
          }
        }
        // if(chartData["Accuracy"][date] == undefined && formattedChartData[3][date] == undefined){
        //   chartData["Accuracy"][date] = data[locName]['table_data'][element]['data']['n'];
        //   formattedChartData[3][date] = data[locName]['table_data'][element]['data']['n'];
        // }
        // else{
        //   chartData["Accuracy"][date] += data[locName]['table_data'][element]['data']['n'];
        //   formattedChartData[3][date] += data[locName]['table_data'][element]['data']['n'];
        // }
      }
      count = count + 1;
    }
    let sortedTimeStampList = timeStampList.sort()
    for (let tp of sortedTimeStampList) {
      blockArray.push(this.utils.convertModelDatetoDate(tp).toLocaleDateString());
    }
    return [chartData, formattedChartData, blockArray, count];
  }

  getChartData(categories,chartData,params) {
    let locType = params['locType'] != 'STATE' ? 'Districts' : 'Blocks'
    let options: object = {
      chart: {
        type: 'column',
        backgroundColor: '#000000' // or any hex, rgb, or rgba value
      },
      title: {
        text: '',
        style: {
          color:'#000'
        }
      },
      xAxis: {
        categories: categories,
        // title: {
        //   text: 'Dates',
        //   style: {
        //     color: '#ffffff'
        //   }
        // },
        labels: {
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', // x-axis label color
          }
        },
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: 'No of ' + locType,
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        labels: {
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', // x-axis label color
          }
        },
        gridLineColor: '#808080'
        // stackLabels: {
        //   enabled: true,
        //   style: {
        //     fontWeight: 'bold'
        //   }
        // }
      },
      legend: {
        enabled:true,
        itemStyle: {
          color: '#9aa2a7ff',
          fontFamily: 'poppins, sans-serif',
        }
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true
          }
        }
      },
      series: [
        {
          name: 'Severe Heatwave',
          type: 'column',
          data: categories.map(date => chartData.SevereHeatwave[date] || 0),
          color: '#FF5A5F'
        },
        {
          name: 'Heatwave',
          type: 'column',
          data: categories.map(date => chartData.Heatwave[date] || 0),
          color: '#FFB347'
        },
        {
          name: 'Normal',
          type: 'column',
          data: categories.map(date => chartData.Normal[date] || 0),
          color: '#4CAF50'
        }
      ],
      credits: {
        enabled: false
      }
    }
    return options;
  }

  // getChartDataForHeatwave(categories,chartData) {
  //   let options: object = {
  //     chart: {
  //       type: 'column',
  //       height: 280,
  //       backgroundColor: '#404040' // or any hex, rgb, or rgba value
  //     },
  //     title: {
  //       text: '',
  //       style: {
  //         color:'#ffffff'
  //       }
  //     },
  //     xAxis: {
  //       categories: categories,
  //       // title: {
  //       //   text: 'Dates',
  //       //   style: {
  //       //     color: '#ffffff'
  //       //   }
  //       // },
  //       labels: {
  //         style: {
  //           color: '#ffffff' // x-axis label color
  //         }
  //       },
  //       crosshair: true
  //     },
  //     yAxis: {
  //       min: 0,
  //       title: {
  //         text: 'No of Districts',
  //         style: {
  //           color: '#ffffff'
  //         }
  //       },
  //       labels: {
  //         style: {
  //           color: '#ffffff' // x-axis label color
  //         }
  //       },
  //       gridLineColor: '#808080'
  //       // stackLabels: {
  //       //   enabled: true,
  //       //   style: {
  //       //     fontWeight: 'bold'
  //       //   }
  //       // }
  //     },
  //     legend: {
  //       enabled: false
  //       // itemStyle: {
  //       //   color: '#ffffff' // legend text color
  //       // }
  //     },
  //     tooltip: {
  //       headerFormat: '<b>{point.x}</b><br/>',
  //       pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
  //     },
  //     plotOptions: {
  //       column: {
  //         stacking: 'normal',
  //         // dataLabels: {
  //         //   enabled: true
  //         // }
  //       }
  //     },
  //     series: [
  //       {
  //         name: 'Severe Heatwave',
  //         type: 'column',
  //         data: categories.map(date => chartData.SevereHeatwave[date] || 0),
  //         color: '#FF5A5F'
  //       },
  //       {
  //         name: 'Heatwave',
  //         type: 'column',
  //         data: categories.map(date => chartData.Heatwave[date] || 0),
  //         color: '#FFB347'
  //       },
  //       {
  //         name: 'Normal',
  //         type: 'column',
  //         data: categories.map(date => chartData.Normal[date] || 0),
  //         color: '#4CAF50'
  //       }
  //     ],
  //     credits: {
  //       enabled: false
  //     },
  //     exporting: {
  //       enabled: false
  //     }
  //   }
  //   return options;
  // }


//  GRADIENT AREA CHART
getChartDataForHeatwave(categories, chartData) {
  let options: object = {
    chart: {
      type: 'area',
      height: 280,
      backgroundColor: '#404040'
    },
    title: {
      text: '',
      style: {
        color: '#000'
      }
    },
    xAxis: {
      categories: categories,
      labels: {
        style: {
          color: '#9aa2a7ff',
          fontFamily: 'poppins, sans-serif',
        }
      },
      crosshair: true
    },
    yAxis: {
      min: 0,
      title: {
        text: 'No of Districts',
        style: {
          color: '#9aa2a7ff',
          fontFamily: 'poppins, sans-serif',
        }
      },
      labels: {
        style: {
          color: '#9aa2a7ff',
          fontFamily: 'poppins, sans-serif',
        }
      },
      gridLineColor: '#808080'
    },
    legend: {
         layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom',
  itemMarginTop: 4,
  itemMarginBottom: 4,
  symbolRadius: 0,
        itemStyle: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
            fontSize: '10px',
    fontWeight: 'normal'
           }
      },
    tooltip: {
      shared: true,
      headerFormat: '<b>{point.x}</b><br/>'
    },
    plotOptions: {
      area: {
        fillOpacity: 0.7,
        marker: {
          enabled: true,
          radius: 5,
          lineWidth: 0,
          lineColor: '#9aa2a7ff'
        }
      }
    },
    series: [
      {
        name: 'Normal',
        color: '#EF4444',
        data: categories.map(date => chartData.Normal[date] || 0),
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, '#FFC4C4'],
            [1, 'rgba(210, 146, 146, 0)']
          ]
        },
        lineColor: '#EF4444',
        lineWidth: 2
      },
      {
        name: 'Heatwave',
        color: '#FFA500',
        data: categories.map(date => chartData.Heatwave[date] || 0),
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, '#FFA500'],
            [1, 'rgba(255, 165, 0, 0.1)']
          ]
        },
        lineColor: '#FFA500',
        lineWidth: 3
      },
      {
        name: 'Severe Heatwave',
        color: '#3B82F6',
        data: categories.map(date => chartData.SevereHeatwave[date] || 0),
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, '#C7E2F5'],
            [1, 'rgba(131, 141, 220, 0.1)']
          ]
        },
        lineColor: '#3B82F6',
        lineWidth: 2
      }
    ],
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    }
  };
  return options;
}

  createLabels(tsList) {
    const labelStrings = [];
    let device = this.utils.getDeviceType()
    let labels
    for (const ts of tsList) {
      if (device == 'mobile') {
        labels = this.utils.convertModelDatetoDateForMobile(ts)
        labels = this.datePipe.transform(labels, "dd/MM")
      }
      else if (device == 'desktop') {
        labels = this.utils.convertModelDatetoDate(ts).toLocaleDateString()
      }
      labelStrings.push({
        groupName: ts,
        label: {
          label: labels,
          toolTip: '5:30 AM - 5:30 AM'
        },
        fullLabel: labels
      });
    }
    return labelStrings;
  }

  setBlockNumber() {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();

    let index;

    if (currentHour > 17 || (currentHour === 17 && currentMinutes >= 30)) {
      // After 5:30 PM
      index = 3;
    } else {
      // Before 5:30 PM
      index = 2;
    }
    return index;
  }

  getLast7DaysDates(queryParams,component) {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();
    let source = queryParams['params']['source']
    let displayDate;
    let dateIndex;
    if(component == 'heatwave') {
      if (currentHour > 17 || (currentHour === 17 && currentMinutes >= 30)) {
        // After 5:30 PM
        // displayDate = currentDate;
        dateIndex = source != 'ECMWF' ? 10 : 46;
      } else {
        // Before 5:30 PM
        // const yesterday = new Date(currentDate);
        // yesterday.setDate(currentDate.getDate() - 3); // Set date to yesterday
        // displayDate = yesterday;
        dateIndex = source != 'ECMWF' ? 9 : 45;
      }
    } else {
      dateIndex = 9
    }
    const yesterday = new Date(currentDate);
    if(component == 'heatwave') {
      yesterday.setDate(currentDate.getDate() - 3); // Set date to yesterday
    }
    displayDate = yesterday;
    let dateBlockNumMap = {};
    for (let i = 0; i < dateIndex; ++i) {
      dateBlockNumMap[
        this.datePipe.transform(displayDate, "yyyy-MM-dd").split("-").join("")
      ] = i;
      displayDate.setDate(displayDate.getDate() + 1);
    }
    return dateBlockNumMap
  }

  toTitleCase(str: string) {
    const strng = [];
    str.split(' ').forEach((st: string) => {
      strng.push(st[0].toUpperCase() + st.substr(1).toLowerCase());
    });
    return strng.join(' ');
  }

  formatOverallAccuracyData(data) {
    let currentDate = this.getCurrentDateInYYYYMMDDFormat()
    // if (data.length > 0) {
    //   let accuracyData = ((data[0]['table_data'][currentDate]['accuracy']) * 100).toFixed(2);
    //   return accuracyData;
    // }
    if (data.length > 0) {
      let accuracyData = null;
      for (let i = 0; i < data[0]['table_data'].length; i++) {
        let tableDataItem = data[0]['table_data'][i];
        let timeStamp = tableDataItem['timeStamp'].toString();
        let tableDataDate = timeStamp.substring(0, 8);
        if (tableDataDate === currentDate) {
          accuracyData = (tableDataItem['data']['accuracy'] * 100).toFixed(2);
          break;
        }
      }
      return accuracyData;
    } else {
      return null; // or handle the case when data is empty
    }
  }

  getOverallAccuracyDataForState(actualData, stateUUID) {
    for (let i in actualData) {
      if (actualData[i].uuid == stateUUID) {
        let accuracyData = actualData[i]['table_data'][0]['data']['a'];
        return accuracyData
      }
    }
  }

  deepClone(object: any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj: any = {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }
}
